import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import GameCard from '@/components/feature/GameCard';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { games, categories } from '@/mocks/games';
import { articles } from '@/mocks/articles';
import { faqData, testimonials, statsData } from '@/mocks/siteData';

export default function Home() {
  const latestGames = games.slice(0, 8);
  const popularArticles = articles.slice(0, 3);

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黄游免费下载',
    url: 'https://huangyou-free-download.com',
    description: '海量黄游免费下载资源，涵盖各类热门黄游，安全快速，持续更新',
    sameAs: [],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黄游免费下载',
    url: 'https://huangyou-free-download.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://huangyou-free-download.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20fantasy%20gaming%20atmosphere%20with%20mysterious%20characters%20silhouettes%2C%20dramatic%20lighting%2C%20rich%20warm%20amber%20and%20deep%20crimson%20colors%2C%20epic%20cinematic%20composition%2C%20fantasy%20game%20art%20style%2C%20atmospheric%20and%20immersive&width=1800&height=900&seq=home-hero-bg&orientation=landscape"
            alt="黄游免费下载"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

          <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
              <i className="ri-sparkling-line text-amber-300 text-sm"></i>
              <span className="text-background-50/90 text-sm font-medium">持续更新 · 安全下载 · 完全免费</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
              黄游免费下载 - 最新资源合集
            </h1>
            <p className="text-background-50/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
              为您精选海量黄游免费下载资源，涵盖各类热门黄游，无需付费即可体验，支持一键下载，安全快速，持续更新，满足您的黄游免费下载需求
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/rpg"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/30 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-cloud-2-line mr-2"></i>
                立即探索资源
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-base hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line mr-2"></i>
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="relative -mt-16 z-20 px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <div className="bg-background-50 rounded-2xl border border-background-200/70 grid grid-cols-2 md:grid-cols-4 divide-x divide-background-200/70 shadow-sm">
              {statsData.map((stat, index) => (
                <div key={index} className="p-5 md:p-7 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                    <i className={`${stat.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">{stat.value}</div>
                  <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Category Section */}
        <section className="py-16 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                热门游戏分类
              </h2>
              <p className="text-foreground-500 text-base max-w-2xl mx-auto">
                八大热门分类，覆盖所有黄游类型，总有一款适合你
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${cat.icon} text-accent-600 text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">{cat.name}</h3>
                  <span className="text-xs text-foreground-400">{cat.count} 款游戏</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Games Section */}
        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  最新游戏资源
                </h2>
                <p className="text-foreground-500 text-sm">
                  每日更新，第一时间获取最新黄游免费下载资源
                </p>
              </div>
              <Link
                to="/category/rpg"
                className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
              {latestGames.map((game) => (
                <GameCard key={game.id} {...game} />
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-16 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                精选攻略文章
              </h2>
              <p className="text-foreground-500 text-base max-w-2xl mx-auto">
                游戏评测、下载指南、攻略秘籍，助你畅玩无忧
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {popularArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>

            <div className="text-center mt-10">
              <Link
                to="/category/rpg"
                className="inline-flex items-center gap-1 px-6 py-3 rounded-full border border-background-300 text-foreground-600 font-medium text-sm hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer"
              >
                浏览更多文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                玩家口碑评价
              </h2>
              <p className="text-foreground-500 text-base">
                来自真实玩家的反馈，98.6%的好评率
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((item, index) => (
                <div
                  key={index}
                  className="p-6 rounded-xl bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < item.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                    &ldquo;{item.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-accent-700 font-semibold text-xs">{item.name.charAt(0)}</span>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                      <div className="text-xs text-foreground-400">{item.date}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 md:py-20 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                常见问题解答
              </h2>
              <p className="text-foreground-500 text-base">
                关于黄游免费下载的常见疑问，这里都有答案
              </p>
            </div>

            <div className="space-y-3">
              {faqData.map((item, index) => (
                <details
                  key={index}
                  className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-5 cursor-pointer select-none">
                    <h3 className="font-heading font-semibold text-foreground-800 text-base pr-4">
                      {item.question}
                    </h3>
                    <div className="w-6 h-6 rounded-full bg-background-100 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform duration-200">
                      <i className="ri-add-line text-foreground-500 text-sm"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-foreground-600 text-sm leading-relaxed">{item.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-primary-600 text-2xl"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              订阅最新资源推送
            </h2>
            <p className="text-foreground-500 text-base mb-8">
              第一时间获取最新黄游免费下载资源更新通知
            </p>

            <form
              data-readdy-form
              id="newsletter-form"
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
              action="https://readdy.ai/api/form/d9qu3a4nlsngrm4lm630"
              method="POST"
            >
              <input
                type="email"
                name="email"
                required
                placeholder="请输入您的邮箱地址"
                className="flex-1 px-5 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <button
                type="submit"
                className="px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                立即订阅
              </button>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
            </form>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}